export default __webpack_public_path__ + "images/a385c413c63b11c855ea455bce521968-EE_SlideDeckBOOK1024_1.png";